/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper, getApiVersionHeader } from '@hems/service/src/util/apiHelper';
export default class StatisticsService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** 사이트 상세 차트 조회 */
    getSiteStatistics = async (siteId, params) => {
        const { data } = await this.get(apiWrapper.managerApi(`/histories/graphs/${siteId}/ac-system`), params, {
            headers: getApiVersionHeader(),
        });
        return data.body;
    };
    /** 장비 overview 차트 조회 */
    getDeviceCount = async (params) => {
        const { data } = await this.get(apiWrapper.stateApi('/devices/charts/data/renewal'), params);
        return data;
    };
    /** 지난 주 설치 장비 대수 조회 */
    getLastWeekInstalledDeviceCount = async (params) => {
        const { data } = await this.get(apiWrapper.managerApi('/managements/activities/instl-last-week'), params);
        return data;
    };
}
export { StatisticsService };
